module.exports = __webpack_public_path__ + "static/context-menu-e06336f2ce000cd7cb2fc232f5250ea2.png";